<template>
  <reports-container-organic></reports-container-organic>
</template>
<script>
import ReportsContainerOrganic from "../../apps/positions/reports/ReportsContainerOrganic";

export default {
  components: {ReportsContainerOrganic}
};
</script>
<style>

</style>
